import {
    apiRequest,
    penilaianList,
    penilaianInactive,
    penilaianActive,
    penilaianDetail
} from "../../../../../services/adapters/kepegawaian/penilaianService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", penilaianList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", penilaianInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", penilaianActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", penilaianDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default DataTableRepository